exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host(jhi-footer){width:100%;min-height:5px}.footer{padding:10px 0}hr{margin-bottom:0;margin-top:1em}.copyright,a,span{text-align:center;height:12px;line-height:normal;letter-spacing:-.2px;color:#5a5858}li,ul{display:inline-block}li{margin:4px 20px}.copyright a{border-bottom:1px solid #e1e1e1}.copyright a:hover{text-decoration:none;border-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/layouts/footer/footer.component.scss
// module id = 700
// module chunks = 0